import React from "react"
import { makeStyles } from "tss-react/mui"
import { Button, Typography } from "@mui/material"
import BlockIcon from "@mui/icons-material/Block"

const useStyles = makeStyles()((theme) => ({
  // Full-screen scrim that blocks the chat underneath. Mirrors ReconnectModal so
  // the two "session ended" surfaces feel consistent. Sits above everything.
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: theme.zIndex.modal + 10,
    backgroundColor: "rgba(15, 17, 21, 0.72)",
    backdropFilter: "blur(2px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  card: {
    width: 360,
    maxWidth: "90vw",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    textAlign: "center",
    boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
  },
  icon: {
    fontSize: 40,
    color: theme.palette.error.main,
  },
  title: {
    fontWeight: 700,
    fontSize: "1.05rem",
    color: theme.palette.text.primary,
  },
  detail: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
  },
  actions: {
    display: "flex",
    marginTop: theme.spacing(1),
    width: "100%",
    justifyContent: "center",
  },
  okButton: {
    backgroundColor: theme.palette.primary.main,
    color: "#000",
    fontWeight: 600,
    "&:hover": { backgroundColor: theme.palette.primary.dark },
  },
}))

/**
 * "You have been kicked" modal. Shown when an admin removes this user from the
 * room — the server has already disconnected the socket; this is the terminal
 * notice. Dismissing returns to the instance auth/home screen.
 *
 * Props:
 *   kickedBy - username of the admin who kicked (string) | null. null = hidden.
 *   onDismiss - acknowledge + return home
 */
const KickedModal = ({ kickedBy, onDismiss }) => {
  const { classes } = useStyles()
  if (!kickedBy) return null

  return (
    <div className={classes.overlay}>
      <div className={classes.card}>
        <BlockIcon className={classes.icon} />
        <Typography className={classes.title}>You have been kicked</Typography>
        <Typography className={classes.detail}>
          You were removed from the room by {kickedBy}.
        </Typography>
        <div className={classes.actions}>
          <Button
            variant="contained"
            className={classes.okButton}
            onClick={onDismiss}
            disableElevation
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  )
}

export default KickedModal
